import AdminClientPane from './AdminClientPane';

export default AdminClientPane;